// extracted by mini-css-extract-plugin
module.exports = {"image":"Image_image__uaBp_","fade":"Image_fade__G4jMv","isVisible":"Image_isVisible__EXIHH","heroImage":"Image_heroImage__DLFGw"};